import React from 'react';
import { BGLoadingIndicator } from '../BGLoadingIndicator/BGLoadingIndicator';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen w-full bg-bg-tertiary">
      <BGLoadingIndicator size="md" />
    </div>
  );
};

